import _default from './Modal';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/modules/Modal/index.js
// module id = 266
// module chunks = 0